/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagAIcon16Light = forwardRef('FlagAIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 15.5a.5.5 0 0 0 1 0V11h10.5a.5.5 0 0 0 .4-.8l-2.775-3.7L13.9 2.8a.5.5 0 0 0-.4-.8h-10A1.5 1.5 0 0 0 2 3.5v12ZM3.5 3a.5.5 0 0 0-.5.5V10h9.5l-2.4-3.2a.5.5 0 0 1 0-.6L12.5 3h-9Z" })));
});
